import { render, staticRenderFns } from "./mainSafetyHealthyTargetDetailPopup.vue?vue&type=template&id=1c8eb386"
import script from "./mainSafetyHealthyTargetDetailPopup.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyTargetDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8eb386')) {
      api.createRecord('1c8eb386', component.options)
    } else {
      api.reload('1c8eb386', component.options)
    }
    module.hot.accept("./mainSafetyHealthyTargetDetailPopup.vue?vue&type=template&id=1c8eb386", function () {
      api.rerender('1c8eb386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyTargetDetailPopup.vue"
export default component.exports